export class scenarioIdModel
{
  constructor(public scenarioId:string)
  {

  }
}